/**=========================================================
 * Module: statistics.js
 * Stats Controller
 =========================================================*/

App.controller('StatisticsController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService',
   'Restangular', 'DataService', 'ngDialog', '$filter', 'toaster',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog, $filter, toaster) {
    "use strict";

    $scope.id = ($state.params.filter || '').toLowerCase()
    
    if($scope.id=='advanced'){
      $state.go('app.entity', {action:'view',type:'stats',filter:''});
    }

    $scope.page = {
            title: $scope.id ? 'labels.STATISTICSNAME' + $scope.id.toUpperCase() : 'labels.STATS',
            titleParams: {  },
            subTitle: $scope.id ? '' : ''
        };

    $scope.statistics = [
        { name: 'SAVES' },
        { name: 'LANGUAGES' },
        { name: 'SUPPLIERS'},
        { name: 'DELAYS' },
        { name: 'PROCESSED', role: 'ADMIN' },
        { name: 'ADVANCED' }
    ]
    $scope.status = ''

    $scope.statsByRole = function(s){
      return !s.role || s.role == $rootScope.user.groupType;
    }

    $scope.pop = function(type, title, text) {
        toaster.pop(type, title, text, 0, 'trustedHtml');
    };

    $scope.openStatistic = function(id){
      $state.go('app.entity', { action: 'view', type: 'statistics', filter: id.toLowerCase()})
    }

    $scope.init = function(){
      itemsLoaded = {};
      if($rootScope.user.id && $scope.id){
          $scope.initForm();
          if(!$scope.suppliers || $scope.suppliers.length==0){
            if($rootScope.user.admin){
                D.query('group','type=supplier&_withRefs=true', { cache: false }).then(
                    function(response){
                        $scope.suppliers = response;
                        $scope.suppliers.unshift({id:'',name: $filter('translate')('labels.ALL') });
                        itemsLoaded.suppliers = true;
                        $scope.initForm();
                    }
                ).catch(console.error);
          }
          else {
              D.query('reference', $rootScope.user.sgUser ? '_sgAll=true' : '', { cache: false }).then(
                  function(response){
                      $scope.suppliers = response;
                      $scope.suppliers.unshift({supplier:'',supplierName: $filter('translate')('labels.ALL') });
                      itemsLoaded.suppliers = true;
                      $scope.initForm();
                  }
              ).catch(console.error);
          }
        }
        if(!$scope.clients || $scope.clients.length==0){
          if($rootScope.user.admin){
            D.query('group','type=client', { cache: false }).then(
                function(response){
                    $scope.clients = response;
                    $scope.clients.unshift({id:'',name: $filter('translate')('labels.ALL') });
                    itemsLoaded.clients = true;
                    $scope.initForm();
                }
            ).catch(console.error);
          } else {
            itemsLoaded.clients = true;
            $scope.initForm();
          }
        }
      }
    }

    var itemsLoaded = {};
    $scope.suppliers = [];
    $scope.clients = [];

    function setFilterString(){
      $scope.filterString = '';
      if($scope.statForm.model._from_month || $scope.statForm.model._from_year){
        $scope.filterString += $filter('translate')('fields.FROM').toLowerCase();
        if($scope.statForm.model._from_month) $scope.filterString += ' ' + moment().month(parseInt($scope.statForm.model._from_month)-1).format('MMMM')
        if($scope.statForm.model._from_year) $scope.filterString += ' ' + $scope.statForm.model._from_year;
      }
      if($scope.statForm.model._to_month || $scope.statForm.model._to_year){
        $scope.filterString += ' ' + $filter('translate')('fields.TO').toLowerCase();
        if($scope.statForm.model._to_month) $scope.filterString += ' ' + moment().month(parseInt($scope.statForm.model._to_month)-1).format('MMMM')
        if($scope.statForm.model._to_year) $scope.filterString += ' ' + $scope.statForm.model._to_year;
      }
      if($scope.statForm.model.source) $scope.filterString += ($scope.filterString ? ', ' : '') + $filter('translate')('fields.SOURCE').toLowerCase() + ': ' + $filter('translate')('enums.language.' + $scope.statForm.model.source)
      if($scope.statForm.model.target) $scope.filterString += ($scope.filterString ? ', ' : '') + $filter('translate')('fields.TARGET').toLowerCase() + ': ' + $filter('translate')('enums.language.' + $scope.statForm.model.target)
      
      if($scope.filterString) $scope.filterString = '[' + $scope.filterString + ']'
      
      if($scope.statForm.model.client){
        $scope.filterString = $scope.clients.filter(function(c) { return c.id==$scope.statForm.model.client})[0].name  + ' ' + $scope.filterString;
      }

      if($scope.statForm.model.supplier){
        $scope.filterString = getSupplierName($scope.statForm.model) + ' ' + $scope.filterString;
      }

      $scope.filterString = $scope.filterString.trim();
    }
    

    $scope.formInitialized = false;
    $scope.initForm = function(){

        if(itemsLoaded.suppliers && itemsLoaded.clients) 
            {
            $scope.formInitialized = true;

            $scope.status = 'none';
            $scope.statForm = {
                    title: '',
                    status: '',
                    type: 'statdata',
                    model: {},
                    successLabel: ' ',
                    fields: [
                                {
                                  available: $scope.id!='processed',
                                  type: 'monthyear',
                                  name: '_from',
                                  label: 'fields.FROMCONFIRM',
                                  defaultMonth: '1',
                                  defaultYear: 2015,
                                  column: 6,
                                  onchange: function() { $scope.statForm.status = ''; }
                                },
                                {
                                  available: $scope.id!='processed',
                                  type: 'monthyear',
                                  name: '_to',
                                  label: 'fields.TOCONFIRM',
                                  defaultMonth: '12',
                                  defaultYear: new Date().getFullYear(),
                                  column: 6,
                                  onchange: function() { $scope.statForm.status = ''; }
                                },{
                                  available: ['saves'].indexOf($scope.id)>=0,
                                  type: 'language',
                                  name: 'source',
                                  column: 6,
                                  placeholder: 'labels.ALLLANG',
                                  withEmptyOption: true,
                                  onchange: function() { $scope.statForm.status = ''; }
                                },{
                                  available: ['saves'].indexOf($scope.id)>=0,
                                  type: 'language',
                                  name: 'target',
                                  column: 6,
                                  placeholder: 'labels.ALLLANG',
                                  withEmptyOption: true,
                                  onchange: function() { $scope.statForm.status = ''; }
                                },
                                {
                                  available: $rootScope.user.admin,
                                  type: 'select',
                                  name: 'client',
                                  placeholder: 'labels.ALL',
                                  valueField: 'id',
                                  labelField: 'name',
                                  data: $scope.clients,
                                  column: 6,
                                  label: $rootScope.user.admin ? 'fields.CLIENT' : 'fields.GROUP',
                                  onchange: function() { 
                                    $scope.statForm.status = ''; 
                                    if(['delays'].indexOf($scope.id)>=0){
                                      $timeout(function(){
                                          $scope.statForm.fields.filter(function(f){ return f.name=='supplier';})[0].data = $scope.suppliers.filter(function(s){ return !s.refs || !$scope.statForm.model.client || s.refs.indexOf($scope.statForm.model.client)>=0})
                                          if(!$scope.statForm.fields.filter(function(f){ return f.name=='supplier';})[0].data.filter(function(s){ return s.id == $scope.statForm.model.supplier}).length){
                                            $scope.statForm.model.supplier = '';
                                          }
                                      }, 200);
                                      $timeout(function(){
                                          angular.element('select[name=supplier]').chosen('destroy').chosen()
                                      },500);
                                    }
                                  }
                                },
                                {
                                  available: ['delays'].indexOf($scope.id)>=0,
                                  type: 'select',
                                  name: 'supplier',
                                  placeholder: '-',
                                  valueField: $rootScope.user.admin ? 'id' : 'supplier',
                                  labelField: $rootScope.user.admin ? 'name' : 'supplierName',
                                  data: $scope.suppliers,
                                  column: 6,
                                  onchange: function() { $scope.statForm.status = ''; }
                                },{
                                  available: $rootScope.user.admin && $scope.id=='processed',
                                  type: 'text',
                                  name: '_preAqrateCost',
                                  label: 'fields.PREAQRATECOST',
                                  column: 6,
                                  onchange: function() { $scope.statForm.status = ''; }
                                },
                                {
                                    available: true,
                                    type: 'submit',
                                    name: 'empty',
                                    label: 'labels.RUNSTAT'
                                }

                    ],
                    validate: function(){
                      toaster.clear();
                        var errors = [];
                        for(var i=0; i<this.fields.length; i++){
                          var field = this.fields[i];
                          if(field.required && !this.model[field.name]){
                            errors.push({field:field,error:'required'});
                          }

                      }
                        if(errors.length) {
                            var errorMessages ="<ul>";
                            for(var i=0; i<errors.length; i++){
                                var e = errors[i];
                                errorMessages += "<li>"
                                    +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                    +"</li>";
                            }
                            errorMessages += "</ul>";
                            $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                            return false;
                        }
                        else return true;
                    },
                    submit: function(){
                        if(this.validate()){
                            $scope.statForm.status = 'submitting';
                            $scope.status = 'calculating';
                            drawChart['nochart']();
                            $scope.statForm.model._type = $scope.id.toLowerCase();
                            $scope.statForm.model = D.convertDateRangeFilter($scope.statForm.model, '_from', '_to')
                            if($scope.statForm.model.source=='-') delete $scope.statForm.model.source;
                            if($scope.statForm.model.target=='-') delete $scope.statForm.model.target;
                            if($scope.statForm.model.client==='') delete $scope.statForm.model.client;
                            if($scope.statForm.model.supplier==='') delete $scope.statForm.model.supplier;
                            setFilterString();
                            $scope.statForm.model._csvFilename = getChartTitle() + '.csv';
                            D.query('statdata', $scope.statForm.model).then(
                                            function(response){
                                              if(response.length==0){
                                                $scope.status = 'nodata';
                                                $scope.statForm.status = 'submitted';
                                                drawChart['nochart']();
                                              } else {
                                                $scope.statForm.status = 'submitted';
                                                $scope.status = 'calculated';
                                                $scope.cursor = response.cursor;
                                                drawChart[$scope.id](response);
                                              }
                                            },
                                            function(response){
                                                $scope.statForm.status = 'error';
                                                $scope.status = 'error';
                                                drawChart['nochart']();
                                            }
                                        ).catch(console.error);
                        }

                    }
                };
        }
    }

    function saveAs(uri, filename) {
    
      var link = document.createElement('a');
  
      if (typeof link.download === 'string') {
  
          link.href = uri;
          link.download = filename;
  
          //Firefox requires the link to be in the body
          document.body.appendChild(link);
  
          //simulate click
          link.click();
  
          //remove the link when done
          document.body.removeChild(link);
  
      } else {
  
          window.open(uri);
  
      }
    }

    function getChartTitle(title){
      return ($filter('translate')($scope.page.title) + ($scope.filterString ? ' ' + $scope.filterString : '') + (title || '')).replace(/[^a-z0-9]/gi, '_')
    }

    $scope.downloadImage = function(id, title){
      var c = document.getElementById(id || 'ChartRow');
      html2canvas(document.body, {
        width: c.offsetWidth - 40,
        height: c.offsetHeight - 40,
        x: c.offsetLeft + 220,
        y: c.offsetTop + 100
      }).then(function(canvas) {
            saveAs(canvas.toDataURL(), getChartTitle(title));
        }).catch(function(err){
          L.error(err);
        });
    }

    $scope.init();

    $rootScope.$watch('user.id', function(){
        $scope.init();
    });

    $scope.$watch('id', function(){
      $scope.init();
    });

    google.charts.load('current', {'packages':['corechart']});

    var setChartHeight = function(v, containerId){
      document.querySelector('#' + (containerId || 'ChartContainer')).style.height = v + 'px';
    }

    var displayNumber = function(n){
      return $filter('display')(n, {type:'number',decimalSep:$rootScope.user.decimalSep})
    }
    var displayCurrency = function(n, c){
      return $filter('display')(n, {type:'currency',decimalSep:$rootScope.user.decimalSep,currency:c})
    }
    var displayPerc = function(n, total){
      return $filter('display')(n, {type:'perc',total:total});
    }

    $scope.mouseEnterChart = $scope.id==='delays' ? 
      function(e) {
        $scope.showProjectDetail = false;
      } 
      : function () {}

    function placeOverlayText() {
      var cli = this.getChartLayoutInterface();
      var chartArea = cli.getChartAreaBoundingBox();
      
      document.querySelector('.overlay-text').style.width = (chartArea.width) + "px";
      document.querySelector('.overlay-text').style.left = (chartArea.left) + "px";
      document.querySelector('.overlay-text').style.top = (30) + "px";

      if($scope.id=='delays'){
        document.querySelector('.overlay-top-axis').style.width = (chartArea.width) + "px";
        document.querySelector('.overlay-top-axis').style.left = (chartArea.left) + "px";
        document.querySelector('.overlay-top-axis').style.top = (40 + document.querySelector('.overlay-text').offsetHeight) + "px";
      }

      document.querySelector('.overlay-text-saves').style.left = (chartArea.left + chartArea.width/2) + 'px';
      document.querySelector('.overlay-text-saves').style.top = (chartArea.top + chartArea.height/2) + 'px';
    };

    var axisTitleTextStyle = { bold: true, fontSize: 16, italic: false, color: '#656565' };
    var titleTextStyle = { bold: true, fontSize: 16, italic: false, color: '#656565' };
    var fontName = '"Inter", "Open Sans", "Roboto", "Arial", sans-serif';

    function getSupplierName(sd){
      if($rootScope.user.admin){
        return $scope.suppliers.filter(function(s){ return s.id==sd.supplier; })[0].name;
      } else {
        let sup = $scope.suppliers.filter(function(s){ return s.supplier==sd.supplier; })[0]
        return sd.supplierName || (sup && sup.supplierName) || sd.supplier.toUpperCase();
      }
    }

    var drawChart = {
      nochart: function(){
        document.getElementById('ChartContainer').innerHTML = '';
      },
      saves: function(values){
          // Define the chart to be drawn.
          var data = new google.visualization.DataTable();
          data.addColumn('string', 'Type');
          data.addColumn('number', 'Words number');
          data.addColumn({ type:'string', role: 'tooltip' })

          data.addRows([
            [ 
              $filter('translate')('labels.STDSAVESSAVED', { 
                recovered: displayNumber(values[0].total - values[0].normalized), 
                saving: displayCurrency(values[0].totalCost-values[0].normalizedCost, values[0].currency)
              }), 
              values[0].total - values[0].normalized, 
              $filter('translate')('labels.STDSAVESSAVEDLEGEND')
            ],
            [ $filter('translate')('labels.STDSAVESTRANSLATED', { 
                normalized: displayNumber(values[0].normalized), 
                normalizedCost: displayCurrency(values[0].normalizedCost, values[0].currency) 
              }), 
              values[0].normalized, 
              $filter('translate')('labels.STDSAVESTRANSLATEDLEGEND')]
            
          ])

          $scope.displayTotal = displayNumber(values[0].total);
          $scope.displayTotalCost = displayCurrency(values[0].totalCost, values[0].currency);
          $scope.displayNormalizedCost = displayCurrency(values[0].normalizedCost, values[0].currency);
          $scope.displaySaves = displayPerc(values[0].total - values[0].normalized, values[0].total);
          
          var options = {
            colors: ['#CCD515','#157492'],
            fontSize: 14,
            fontName: fontName,
            tooltip: {},
            legend: {
              position: 'labeled'
            },
            pieSliceText: 'none',
            pieStartAngle: -67,
            pieHole: 0.4,
            chartArea: {
              top: 200
            },
            sliceVisibilityThreshold: 0//,
            //title: $filter('translate')('labels.STDSAVESTOTAL', { total: displayNumber(values[0].total), totalCost: displayCurrency(values[0].totalCost), normalizedCost: displayCurrency(values[0].normalizedCost)}) + ' \n ' + $filter('translate')('labels.STDSAVESSAVES', { saves: (values[0].total - values[0].normalized), total: (values[0].total) }),
            //titleTextStyle: titleTextStyle
          }          

          
          setChartHeight(600);
          // Instantiate and draw the chart.
          var chart = new google.visualization.PieChart(document.getElementById('ChartContainer'));
          google.visualization.events.addListener(chart, 'ready', placeOverlayText.bind(chart));
          //google.visualization.events.addListener(chart, 'ready', function () {

            //document.getElementById('DownloadChartButton').href = chart.getImageURI();
          //});
          
          chart.draw(data, options);
        },
      languages: function(values){
        values.sort(function(a, b) { return a.total > b.total ? -1 : 1 });
        var dataArray = [
          [
            $filter('translate')('fields.DESTINATION'), 
            $filter('translate')('fields.TRANSLATED'), 
            { role: 'tooltip' }, 
            $filter('translate')('fields.RECOVERED'), 
            { role: 'tooltip' }, 
            { role: 'annotation' },
            { role: 'annotationText' } 
          ]
        ]
        for(var i=0; i<values.length; i++){
          dataArray.push([
            $filter('translate')('enums.language.'+values[i].target), 
            values[i].normalized, 
            $filter('translate')('fields.TRANSLATED') + ': ' + displayNumber(values[i].normalized),
            values[i].total - values[i].normalized, 
            $filter('translate')('fields.RECOVERED') + ': ' + displayNumber(values[i].total - values[i].normalized), 
            $filter('translate')('labels.STDTOTALWORDS', { total: displayNumber(values[i].total) }),
            $filter('translate')('fields.TOTALWORDS')
          ]);
        }
        var data = google.visualization.arrayToDataTable(dataArray);
  
        var lh = [10, 150, 225, 285, 320, 340, 350, 400, 450, 475, 500, 550, 600, 620, 630, 650, 675, 700, 725, 750, 775, 800, 850, 875, 900, 1000][values.length];
        
        var h = (lh || (values.length * 40)) + 250;

        var options = {
          bar: {
            groupWidth: 20
          },
          fontSize: 14,
          fontName: fontName,
          isStacked: true,
          annotations: {
            highContrast: true,
            textStyle: {
              fontSize: 14,
              fontName: fontName,
              color: '#333'
            },
            stem: {
              color: 'transparent'
            }
          },
          tooltip:{
          },
          legend: {
            position: 'top'
          },
          series: {
            0:{color:'#157492'},
            1:{color:'#CCD515'}
          },
          hAxis: {
            title: $filter('translate')('fields.SIZE'),
            titleTextStyle: axisTitleTextStyle
          },
          vAxis: {
            title: $filter('translate')('fields.DESTINATIONS'),
            titleTextStyle: axisTitleTextStyle
          },
          chartArea: {
            top: 100,
            height: h - 250
          }
        };

        
        /*if(values.length<=5) h += 200;
        if(values.length<=10) h += 100;
        if(values.length<=20) h += 50;*/
        
        setChartHeight(h)
        
        var chart = new google.visualization.BarChart(document.getElementById('ChartContainer'));
        google.visualization.events.addListener(chart, 'ready', placeOverlayText.bind(chart));
        //google.visualization.events.addListener(barChart, 'ready', function () {
          //document.getElementById('DownloadChartButton').href = barChart.getImageURI();
        //});
        chart.draw(data, options);
        
          
        },
        langBySupplier: function(sd){
          var supplierName = getSupplierName(sd);
          $scope.supplierCharts.push({id: sd.supplier, name: supplierName});
          
          D.query('statdata', Object.assign({}, $scope.statForm.model, { supplier: sd.supplier, _type: 'languages' })).then(function(values){
            values.sort(function(a, b) { return a.normalizedCost > b.normalizedCost ? -1 : 1 });
            var data = new google.visualization.DataTable();
            data.addColumn('string', 'Language');
            data.addColumn('number', 'Cost');
            data.addColumn({ type:'string', role: 'tooltip' })

            var dataArray = [];
            for(var i=0; i<values.length; i++){
              if(values[i].normalizedCost){
                dataArray.push([ 
                  $filter('translate')('enums.language.'+values[i].target) + ': ' + $filter('display')(values[i].normalizedCost, {type:'currency',decimals:2,decimalSep:$rootScope.user.decimalSep,currency:values[i].currency}), 
                  values[i].normalizedCost,
                  $filter('translate')('enums.language.'+values[i].target) + ': ' + $filter('display')(values[i].normalizedCost, {type:'currency',decimals:2,decimalSep:$rootScope.user.decimalSep,currency:values[i].currency})
                ]);
              }

            }

            data.addRows(dataArray);

            
            var options = {
              fontSize: 13,
              fontName: fontName,
              title: supplierName,
              titleTextStyle: titleTextStyle,
              sliceVisibilityThreshold: 0
            }          

            setChartHeight(400, 'ChartContainer_'+sd.supplier);
            // Instantiate and draw the chart.
            var chart = new google.visualization.PieChart(document.getElementById('ChartContainer_'+sd.supplier+''));
            google.visualization.events.addListener(chart, 'ready', placeOverlayText.bind(chart));
            //google.visualization.events.addListener(barChart, 'ready', function () {
              //document.getElementById('DownloadChartButton').href = barChart.getImageURI();
            //});
            
            chart.draw(data, options);
          }).catch(console.error)
        },
        suppliers: function(values){
          // Define the chart to be drawn.
          values.sort(function(a, b) { return a.normalizedCost > b.normalizedCost ? -1 : 1 });
          var data = new google.visualization.DataTable();
          data.addColumn('string', 'Supplier');
          data.addColumn('number', 'Cost');
          data.addColumn({ type:'string', role: 'tooltip' })

          //document.getElementById('OthersChartsContainer').innerHTML='';
          $scope.supplierCharts = [];
          var dataArray = [];
          
          var total = 0;
          for(var i=0; i<values.length; i++){
            if(values[i].normalizedCost){
              var supplier = getSupplierName(values[i])
              dataArray.push([ 
                supplier + ': ' + $filter('display')(values[i].normalizedCost, {type:'currency',decimals:2,decimalSep:$rootScope.user.decimalSep,currency:values[i].currency}), 
                values[i].normalizedCost,
                supplier + ': ' + $filter('display')(values[i].normalizedCost, {type:'currency',decimals:2,decimalSep:$rootScope.user.decimalSep,currency:values[i].currency})
              ]);
              drawChart.langBySupplier(values[i]);
              
              total += values[i].normalizedCost;
            }
          }

          data.addRows(dataArray);

          $scope.displayNormalizedCost = displayCurrency(total, values[0].currency);

          var options = {
            fontSize: 14,
            fontName: fontName,
            tooltip: {},
            legend: {
              position: 'right'
            },
            pieSliceText: 'percentage',
            pieStartAngle: 23,
            sliceVisibilityThreshold: 0//,
            //title: $filter('translate')('labels.STDSUPPLIERSTITLE', { total : $filter('display')(total, {type:'currency',decimals:2,decimalSep:$rootScope.user.decimalSep})}),
            //titleTextStyle: titleTextStyle
          }          

          setChartHeight(600);
          // Instantiate and draw the chart.
          var chart = new google.visualization.PieChart(document.getElementById('ChartContainer'));
          google.visualization.events.addListener(chart, 'ready', placeOverlayText.bind(chart));
        //google.visualization.events.addListener(barChart, 'ready', function () {
          //document.getElementById('DownloadChartButton').href = barChart.getImageURI();
        //});
          
          chart.draw(data, options);
        },
        delays: function(values){
          values.sort(function(a, b) { return a.delay > b.delay ? -1 : 1 });
          
          var dataArray = [
            [
              $filter('translate')('fields.PROJECT'), 
              $filter('translate')('fields.DELAY'), 
              { role: 'tooltip' },
              { role: 'annotation' }
            ]
          ]
          var delayed = 0;
          var avgDelay = 0;
          var avgGlobalDelay = 0;
          var projects = [];
          var delayDays = [];
          for(var i=0; i<values.length; i++){
            if(values[i].delay>86400000){
              delayed++;
              projects.push(values[i].project);
              delayDays.push(Math.floor(values[i].delay / 86400000));
              avgDelay += values[i].delay;
              dataArray.push([
                values[i].code, 
                Math.floor(values[i].delay / 86400000),
                $filter('translate')('fields.DELAYDAYS') + ': ' + Math.floor(values[i].delay / 86400000) + (!$scope.statForm.model.supplier ? ' (' + getSupplierName(values[i]) + ')' : ''),
                Math.floor(values[i].delay / 86400000)
              ]);
            }
          }
          if(delayed){
            avgGlobalDelay = Math.floor((avgDelay / values.length) / 86400000);
            avgDelay = Math.floor((avgDelay / delayed) / 86400000);
          } else {
            $scope.status = 'nodata';
            $scope.statForm.status = 'submitted';
            drawChart['nochart']();
            return;
          }
          var data = google.visualization.arrayToDataTable(dataArray);
    
          var lh = [10, 200, 225, 285, 320, 340, 350, 400, 450, 475, 500, 550, 600, 620, 630, 650, 675, 700, 725, 750, 775, 800, 850, 875, 900, 1000][delayed];
          
          var h = (lh || (delayed * 40)) + 250;

          $scope.displayProjects = displayNumber(values.length);
          $scope.displayDelayed = displayNumber(delayed);
          $scope.displayPercProjects = displayPerc(delayed, values.length);
          $scope.displayAvgDelay = avgDelay;
          $scope.displayAvgGlobalDelay = avgGlobalDelay;

          var options = {
            bar: {
              groupWidth: 20
            },
            fontSize: 14,
            fontName: fontName,
            annotations: {
              highContrast: true,
              textStyle: {
                fontSize: 14,
                fontName: fontName,
                color: '#333'
              }
            },
            tooltip:{
            },
            legend: {
              position: 'none'
            },
            series: {
              0:{color:'#157492'}
            },
            hAxis: {
              title: $filter('translate')('fields.DELAYDAYS'),
              minValue: 0,
              titleTextStyle: Object.assign(axisTitleTextStyle, { color: '#157492'})
            },
            vAxis: {
              title: $filter('translate')('fields.DELAYPROJECTS'),
              titleTextStyle: Object.assign(axisTitleTextStyle, { color: '#157492'})
            },
            chartArea: {
              height: h - 390,
              top: 190,
              width: '60%'
            }
          };

          
          setChartHeight(h)
          
          var chart = new google.visualization.BarChart(document.getElementById('ChartContainer'));
          google.visualization.events.addListener(chart, 'ready', placeOverlayText.bind(chart));
          google.visualization.events.addListener(chart, 'click', function(e){ 
            if(e.targetID && e.targetID.indexOf('vAxis')===0 && e.targetID.indexOf('label')>0){
              var index = parseInt(e.targetID.split('#')[e.targetID.split('#').length-1]);
              var project = projects[index];
              if(!project.id){
                $scope.loadingProjectDetail = true;
                D.load('project', project).then(function(resp){
                  $scope.loadingProjectDetail = false;
                  resp.delayDays = delayDays[index];
                  $scope.projectDetail = resp;
                  projects[index] = resp;
                }).catch(console.error)
              } else {
                $scope.loadingProjectDetail = false;
                $scope.projectDetail = project;
              }
              document.querySelector('.overlay-project-detail').style.top = (e.y - 20) + 'px';
              document.querySelector('.overlay-project-detail').style.left = (e.x - 20) + 'px';
              $scope.showProjectDetail = true;
              
            }
           });
          google.visualization.events.addListener(chart, 'onmouseover', function(e){  });
          google.visualization.events.addListener(chart, 'select', function(e){  });
        //google.visualization.events.addListener(barChart, 'ready', function () {
          //document.getElementById('DownloadChartButton').href = barChart.getImageURI();
        //});
          chart.draw(data, options);

      
            
        },

        processed: function(values){
          var data = new google.visualization.DataTable();
          data.addColumn('string', $filter('translate')('fields.YEAR'));
          data.addColumn('number', $filter('translate')('fields.PROCESSEDWORDSCOST'));
          data.addColumn({role:'annotation'})
          data.addColumn({'type': 'string', 'role': 'style'})
          values.sort(function(a, b) { return a.year < b.year ? -1 : 1 })
          var dataArray = [];
          for(var i=0; i<values.length; i++){
            if(i==0 && $scope.statForm.model._preAqrateCost){
              dataArray.push([ 
                '' + (values[i].year-1), 
                parseFloat($scope.statForm.model._preAqrateCost.replace($rootScope.user.decimalSep, '.')),
                $filter('display')(parseFloat($scope.statForm.model._preAqrateCost.replace($rootScope.user.decimalSep, '.')), { type: 'currency', decimals: 3, decimalSep:$rootScope.user.decimalSep,currency:values[i].currency }) + ' ' + $filter('translate')('labels.STDPROCESSEDBEFOREAQR'),
                'point { fill-color: #CCD515; }'
              ]);
            }
            dataArray.push([ 
              ''+values[i].year, 
              values[i].wordCost,
              $filter('display')(values[i].wordCost, { type: 'currency', decimals: 3, decimalSep:$rootScope.user.decimalSep,currency:values[i].currency }),
              null
            ])
          }
          data.addRows(dataArray);

          setChartHeight(500)

          var options = {
            colors: ['#157492'],
            pointSize: 8,
            pointsVisible: true,
            legend: {
              position: 'none'
            },
            tooltip: {
              trigger: 'none'
            },
            hAxis: {
              title: $filter('translate')('fields.YEAR'),
              titleTextStyle: axisTitleTextStyle
            },
            vAxis: {
              title: $filter('translate')('fields.PROCESSEDWORDSCOST'),
              titleTextStyle: axisTitleTextStyle
            },
            
          };

          var chart = new google.visualization.LineChart(document.getElementById('ChartContainer'));
          google.visualization.events.addListener(chart, 'ready', placeOverlayText.bind(chart));
        //google.visualization.events.addListener(barChart, 'ready', function () {
          //document.getElementById('DownloadChartButton').href = barChart.getImageURI();
        //});
          chart.draw(data, options);
        }
    }

  }]);
